import { render, staticRenderFns } from "./NotesCrad.vue?vue&type=template&id=327dccbc&"
import script from "./NotesCrad.vue?vue&type=script&lang=js&"
export * from "./NotesCrad.vue?vue&type=script&lang=js&"
import style0 from "./NotesCrad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports